import ee from '../../shared/pub_sub';
import Cookie from 'js-cookie';

$(document).ready(function() {
  $('.two-step__decline').on('click', e => {
    ee.emit('two_step:decline', {
      id: e.target?.id,
      text: e.target?.innerText,
    });
  });

  $('.two-step__accept').on('click', e => {
    const id = e.target?.id || e.currentTarget?.id;
    ee.emit('two_step:accept', { id, text: e.target?.innerText });
    if (id === 'donate-two-step-accept') {
      if (typeof window.fbq === 'function') {
        try {
          const userId =
            window.champaign.personalization.member?.id || Cookie.get('__bpmx');
          window.fbq(
            'trackCustom',
            'PostActionDonateYes',
            {
              user_id: userId,
            },
            { eventID: window.champaign.personalization.unique_id }
          );
        } catch (e) {
          console.error(e);
        }
      }
    }
  });
});
